<template>
  <v-container fluild>
    <Loading v-if="loadingCompany || loadingUsers" />
    <TabViews v-else :vertical="false" :centered="false" :tabs="companyTabs" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Loading from '@components/common/Loading.vue';
import TabViews from '@components/common/TabViews.vue';

export default {
  name: 'Company',
  components: {
    Loading,
    TabViews,
  },
  props: ['cid'],
  data() {
    return {
      companyTabs: [
        {
          tabId: 'employees',
          title: 'Employees',
          icon: 'perm_contact_calendar',
          route: `/company/${this.cid}/employees`,
        },
        {
          tabId: 'teams',
          title: 'Teams',
          icon: 'group',
          route: `/company/${this.cid}/teams`,
        },
      ],
    };
  },
  methods: {
    ...mapActions(['getCompany', 'getEmployeesByCompanyId']),
  },
  computed: {
    ...mapGetters(['currentUser', 'currentCompany', 'loadingCompany', 'loadingUsers']),
  },
  created() {
    this.getEmployeesByCompanyId(this.currentCompany.cid);
  },
};
</script>
